import { css, Theme } from "@emotion/react";
import { media } from "styles/breakpoints";

export const SupplierBlockStyle = {
  self: css`
    max-width: 1480px;
    padding: 20px;

    margin: 0 auto;
    ${media.xxl} {
      padding: 0 60px;
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  `,
  title: ({ fontSize }: Theme) => css`
    font-size: ${fontSize[20]};
    font-weight: 500;
    text-transform: uppercase;
    text-align: center;
    margin-bottom: 30px;
  `,
};
